class PreorderShippingDate extends HTMLElement {
    constructor() {
        super();
        this.dateElement = null;
        this.variantShippingDates = null;
        this.preorderVariants = [];
    }

    connectedCallback() {
        this.dateElement = this.querySelector('[data-shipping-date]');
        const variantShippingDatesScript = document.querySelector('script[data-variant-shipping-dates]');
        const preorderVariantsScript = document.querySelector('script[data-preorder-variants-json]');

        if (!this.dateElement || !variantShippingDatesScript) {
            return;
        }

        this.variantShippingDates = this.parseJSON(variantShippingDatesScript.textContent);
        this.preorderVariants = preorderVariantsScript ? this.parseJSON(preorderVariantsScript.textContent) : [];

        this.init();
    }

    parseJSON(jsonString) {
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            return null;
        }
    }

    init() {
        if (!this.variantShippingDates) return;

        this.classList.remove('visible');

        document.addEventListener('theme:variant:change', (event) => {
            this.updateShippingDate(event.detail.variant);
        });
    }

    updateShippingDate(variant) {
        if (!variant) return;

        const variantId = variant.id.toString();
        const shippingDate = this.variantShippingDates[variantId];
        const isPreorderVariant = this.preorderVariants.includes(variant.id);

        if (shippingDate && isPreorderVariant) {
            this.dateElement.textContent = shippingDate;
            this.classList.add('visible');
        } else {
            this.classList.remove('visible');
        }
    }
}

if (!customElements.get('preorder-shipping-date')) {
    customElements.define('preorder-shipping-date', PreorderShippingDate);
}